import { Injectable, signal, Signal } from "@angular/core";
import GeobusNavigationExtension from "./geobus-navigation.extension";
import { IType } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })
export default class GeobusFTPServerExtension extends GeobusNavigationExtension {

    public get component(): IType<unknown> | null {
        return null;
    }

    public get identifier(): string | null {
        return "GeobusFTPServerExtensionName";
    }

    public get title(): Signal<string> {
        return signal("SIDE_MENU.DATA.FTP_SERVER").asReadonly();
    }

    public get category(): string {
        return "data";
    }

    public get state(): { name: string } {
        return { name: "app.ftpServer" };
    }

    public get icon(): string {
        return "binder";
    }

}
